import React, { memo } from "react";
import PropTypes from "prop-types";
import {
  Button,
  ButtonGroup,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from "@chakra-ui/react";
import * as PostEditorActions from "./PostEditorActions.constants";
import PostEditorDateTimeButton from "./PostEditorDateTimeButton";
import PostEditorDateTimePicker from "./PostEditorDateTimePicker";
import { translate as trans } from "../Trans/Trans";

const PostEditorEditPostButtons = ({
  isLoading,
  isDisabled,
  date,
  time,
  timezone,
  defaultTimezone,
  onTimeChange,
  onSave,
  hideTimeSelector,
}) => (
  <ButtonGroup size="sm">
    {hideTimeSelector ? null : (
      <Popover isLazy placement="bottom-start">
        <PopoverTrigger>
          <PostEditorDateTimeButton
            variant="outline"
            date={date}
            time={time}
            timezone={timezone}
            isDisabled={!!isLoading}
          />
        </PopoverTrigger>
        <PopoverContent width="auto" padding="3">
          <PopoverArrow />
          <PostEditorDateTimePicker
            required
            date={date}
            time={time}
            timezone={timezone}
            defaultTimezone={defaultTimezone}
            onChange={onTimeChange}
          />
        </PopoverContent>
      </Popover>
    )}
    <Button
      variant="solid"
      onClick={onSave}
      isDisabled={isDisabled || !!isLoading}
      isLoading={isLoading === PostEditorActions.SAVE}
    >
      {trans("post_editor.actions.save")}
    </Button>
  </ButtonGroup>
);

PostEditorEditPostButtons.propTypes = {
  isLoading: PropTypes.oneOf(Object.values(PostEditorActions)),
  isDisabled: PropTypes.bool,
  hideTimeSelector: PropTypes.bool,
  date: PropTypes.string,
  time: PropTypes.string,
  timezone: PropTypes.string,
  defaultTimezone: PropTypes.string,
  onTimeChange: PropTypes.func,
  onSave: PropTypes.func,
};

PostEditorEditPostButtons.defaultProps = {
  isLoading: undefined,
  isDisabled: undefined,
  hideTimeSelector: undefined,
  date: undefined,
  time: undefined,
  timezone: undefined,
  defaultTimezone: undefined,
  onTimeChange: undefined,
  onSave: undefined,
};

export default memo(PostEditorEditPostButtons);
